module.exports = __webpack_public_path__ + "static/media/o11.5146688e.png";